/* src/app/location-users/add-location-users/import-error-modal/import-error-modal.component.scss */
.modal-header {
  border-bottom: none;
  padding: 22px 16px 16px 60px;
}
.modal-body {
  padding: 0 60px;
  border-bottom: none;
}
.modal-footer {
  padding: 0 0 24px 0;
  border-top: none;
}
.btn {
  margin-top: 32px;
  height: 36px;
  border-radius: 100px;
  border: 0;
  padding-right: 28px;
  padding-left: 28px;
}
.btn-green {
  color: white;
  background-color: #00857D;
}
/*# sourceMappingURL=import-error-modal.component.css.map */
